import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MatchHeaderUpcoming from '../components/MatchDetails/MatchHeaderUpcoming';
import TeamForm from '../components/MatchDetails/TeamForm';
import MatchUpStandings from '../components/MatchDetails/MatchUpStandings';
import TeamNews from '../components/MatchDetails/TeamNews';
import TopPlayers from '../components/MatchDetails/TopPlayers';
import { LEAGUES } from '../constants/leagues';
import Tabs from '../components/MatchDetails/Tabs';
import { MATCH_STATUS } from '../constants/match';
import Formation from '../components/MatchDetails/Formation';
import Timeline from '../components/MatchDetails/Timeline';

function getInitialTab(status, lineupsAvailable) {
  if (status === MATCH_STATUS.UPCOMING && lineupsAvailable) {
    return 1;
  }

  return 0;
}

function getLineupsAvailable(match) {
  const homeTeamLineupAvailable = match?.homeTeamLineup?.starting?.length > 0;
  const visitingTeamLineupAvailable =
    match?.visitingTeamLineup?.starting?.length > 0;

  return homeTeamLineupAvailable && visitingTeamLineupAvailable;
}
function MatchDetailsUpcoming({
  match,
  homeTeamLogo,
  visitingTeamLogo,
  teamLogos,
}) {
  const [currentTab, setCurrentTab] = useState(
    getInitialTab(match?.status, getLineupsAvailable(match))
  );

  const switchContent = (newTab) => {
    setCurrentTab(newTab);
  };

  return (
    <>
      <MatchHeaderUpcoming
        match={match}
        homeTeamLogo={homeTeamLogo}
        visitingTeamLogo={visitingTeamLogo}
      />
      <div className="site-container">
        {match?.configLeagueName !== LEAGUES.FUTSAL && (
          <div className="col-12 text-center mb-4 d-none d-lg-block">
            <a href="https://www.discoveryplus.se/" target="_blank" rel="nofollow noreferrer">
              <img
                height="24"
                src="/wp-content/themes/sef-leagues/images/discovery-plus-logo-white.svg"
                alt=""
              />
            </a>
          </div>
        )}
        <Tabs
          switchContent={switchContent}
          initialTab={getInitialTab(match?.status, getLineupsAvailable(match))}
        />
        {currentTab === 1 && <Timeline match={match} />}
        {match?.configLeagueName !== LEAGUES.FUTSAL && currentTab === 2 && (
          <>
            {getLineupsAvailable(match) && (
              <>
                <Formation match={match} homeTeam />
                <Formation match={match} homeTeam={false} />
              </>
            )}
            {!getLineupsAvailable(match) && (
              <div className="col-12 data-container data-container--reverse-gradient py-5 mt-4 text-center text-regular">
                Laguppställningarna är inte tillgängliga än.
              </div>
            )}
          </>
        )}
        {currentTab === 0 && (
          <TeamForm
            match={match}
            homeTeamLogo={homeTeamLogo}
            visitingTeamLogo={visitingTeamLogo}
          />
        )}
        {currentTab === 0 && (
          <MatchUpStandings match={match} teamLogos={teamLogos} />
        )}
        {currentTab === 0 && (
          <>
            <TeamNews
              teamLogo={homeTeamLogo}
              abbrv={match?.homeTeamAbbrv}
              teamName={match?.homeTeamName}
            />
            <TeamNews
              teamLogo={visitingTeamLogo}
              abbrv={match?.visitingTeamAbbrv}
              teamName={match?.visitingTeamName}
            />
          </>
        )}
        {match?.configLeagueName !== LEAGUES.FUTSAL && currentTab === 0 && (
          <TopPlayers match={match} />
        )}
      </div>
    </>
  );
}

MatchDetailsUpcoming.propTypes = {
  match: PropTypes.shape({
    homeTeamAbbrv: PropTypes.string.isRequired,
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    visitingTeamAbbrv: PropTypes.string.isRequired,
  }).isRequired,
  homeTeamLogo: PropTypes.string.isRequired,
  visitingTeamLogo: PropTypes.string.isRequired,
  teamLogos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default MatchDetailsUpcoming;
